import VerifyEmail from "components/Auth/VerifyEmail";
import React from 'react';
export default {
  VerifyEmail,
  React
};